import { Component, Input } from '@angular/core';
import { VitalMetricRecord, VitalMetricsTable } from './vital-metrics.interface';

@Component({
  selector: 'app-vital-metrics-table',
  templateUrl: './vital-metrics-table.component.html',
  styleUrls: ['./vital-metrics-table.component.scss'],
  standalone: false,
})
export class VitalMetricsTableComponent {
  records: VitalMetricRecord[];
  totalRows: number;

  @Input()
  set sourceData(tableData: VitalMetricsTable) {
    this.records = tableData ? tableData.records : [];
    this.totalRows = this.records ? this.records.length : 0;
  }
}
